import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="bg-graphite px-3 py-4 sm:px-6" data-id="element-157" data-mp="3kqw54mwtl6h6">
      <div className="mx-auto max-w-2xl" data-id="element-158" data-mp="3fz5pc1f45qid">
        <h2 className="text-center font-display text-[1.6rem] font-bold uppercase leading-none text-white sm:text-[2.2rem]" data-id="element-159" data-mp="3fy316196e265">
          WHAT SAFETY PROFESSIONALS <span className="text-safety" data-id="element-160" data-mp="36ypqx6d899kd">ARE SAYING</span>
        </h2>
        <div className="mt-2 space-y-2" data-id="element-161" data-mp="36wwfzevl036k">
          {testimonials.map(t => <figure key={t.name} className="rounded-md border border-steel/60 border-l-4 border-l-safety bg-carbon px-2.5 py-2" data-id="element-162" data-mp="31ybhpkzw3tkr">
              <div className="flex gap-0.5 text-safety" role="img" aria-label="5 out of 5 stars" data-id="element-163" data-mp="2s1q8engu7wb4">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-3.5 w-3.5 fill-current" aria-hidden="true" data-id="element-164" data-mp="v8ws66kuleb4" data-mpi={i} />)}
              </div>
              <p className="mt-1 text-[0.95rem] font-extrabold leading-tight text-white sm:text-[1.1rem]" data-id="element-165" data-mp="q8ivfkop5qse">
                “{t.headline}”
              </p>
              <blockquote className="mt-0.5 text-[0.78rem] leading-[1.4] text-mist sm:text-[0.9rem]" data-id="element-166" data-mp="m5sy0dstxumk">“{t.quote}”</blockquote>
              <figcaption className="mt-1.5 text-[0.7rem] leading-tight sm:text-[0.8rem]" data-id="element-167" data-mp="79le7elc2v7t">
                <span className="font-extrabold text-safety" data-id="element-168" data-mp="c7deox01npnm">— {t.role}</span>
                <span className="text-mist" data-id="element-169" data-mp="zxhc2mmn2t66">
                  {' '}
                  · {t.name} · {t.location}
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}